import * as e from "react";
import a from "../lib/IconBase.es.js";
import f from "../defs/CheckSquareOffset.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: f }));
o.displayName = "CheckSquareOffsetIcon";
const m = o;
export {
  m as CheckSquareOffset,
  o as CheckSquareOffsetIcon
};
